import { motion, useReducedMotion } from "framer-motion";
import type { PropsWithChildren } from "react";

type FadeInProps = PropsWithChildren<{
  className?: string;
  delay?: number;
  direction?: "up" | "left" | "right";
}>;

export function FadeIn({ children, className, delay = 0, direction = "up" }: FadeInProps) {
  const reduceMotion = useReducedMotion();
  const offset = direction === "up" ? { y: 34 } : direction === "left" ? { x: -34 } : { x: 34 };

  return (
    <motion.div
      className={className}
      initial={reduceMotion ? { opacity: 0 } : { opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, amount: 0.18 }}
      transition={{ duration: reduceMotion ? 0.2 : 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
